import React from 'react';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';

const Pagination = ({ currentPage, totalPages, onPageChange, totalItems, itemsPerPage }) => (
  totalItems > itemsPerPage && (
    <div className="flex flex-col sm:flex-row justify-between items-center gap-4 py-2">
      <div className="text-sm text-gray-500 font-medium">
        Showing <span className="text-indigo-600 font-bold">{(currentPage - 1) * itemsPerPage + 1}</span> to <span className="text-indigo-600 font-bold">{Math.min(currentPage * itemsPerPage, totalItems)}</span> of <span className="text-gray-900 font-bold">{totalItems}</span> clients
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`flex items-center gap-1 px-4 py-2 rounded-xl text-sm font-bold transition-all border ${currentPage === 1
            ? 'bg-gray-50 text-gray-300 border-gray-100 cursor-not-allowed'
            : 'bg-white text-gray-700 border-gray-200 hover:border-indigo-500 hover:text-indigo-600 shadow-sm'
            }`}
        >
          <BiChevronLeft size={20} />
          <span>Previous</span>
        </button>

        <div className="flex items-center gap-1 mx-2">
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i + 1}
              onClick={() => onPageChange(i + 1)}
              className={`w-10 h-10 rounded-xl text-sm font-bold transition-all ${currentPage === i + 1
                ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-100'
                : 'bg-transparent text-gray-500 hover:bg-gray-100'
                }`}
            >
              {i + 1}
            </button>
          ))}
        </div>

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`flex items-center gap-1 px-4 py-2 rounded-xl text-sm font-bold transition-all border ${currentPage === totalPages
            ? 'bg-gray-50 text-gray-300 border-gray-100 cursor-not-allowed'
            : 'bg-white text-gray-700 border-gray-200 hover:border-indigo-500 hover:text-indigo-600 shadow-sm'
            }`}
        >
          <span>Next</span>
          <BiChevronRight size={20} />
        </button>
      </div>
    </div>
  )
);

export default Pagination;